<router-outlet />
<app-spinner
  #appSpinner
></app-spinner>
